/* const crypto = require('crypto');
import NodeRSA from 'encrypt-rsa'; */
import crypto from 'crypto';
import NodeRSA from 'encrypt-rsa';
export class CifradoAES {
    constructor() {
        this.algoritmoCifrado = 'aes-256-cbc';
        this.keyCifrado = crypto.randomBytes(32);
        this.ivCifrado = crypto.randomBytes(16);
    }
    get llave() {
        return this.keyCifrado.toString('hex');
    }
    get iv() {
        return this.ivCifrado.toString('hex');
    }
    cifrar(text) {

        // Creating Cipheriv with its parameter
        let cipher =
            crypto.createCipheriv(this.algoritmoCifrado, Buffer.from(this.keyCifrado), this.ivCifrado);

        // Updating text
        let encrypted = cipher.update(text);

        // Using concatenation
        encrypted = Buffer.concat([encrypted, cipher.final()]);

        // Returning iv and encrypted data
        return {
            iv: this.ivCifrado.toString('hex'),
            datos: encrypted.toString('hex')
        };
    }

    descifrar(text, IV, key) {

        let iv = Buffer.from(IV, 'hex');
        let encryptedText =
            Buffer.from(text, 'hex');

        // Creating Decipher
        let decipher = crypto.createDecipheriv(
            this.algoritmoCifrado, Buffer.from(key, 'hex'), iv);

        // Updating encrypted text
        let decrypted = decipher.update(encryptedText);
        decrypted = Buffer.concat([decrypted, decipher.final()]);

        // returns data after decryption
        return decrypted.toString();
    }
}

export class CifradoRSA {
    constructor() {
        this.nodeRSA = new NodeRSA();
    }
    async generar_llaves() {
        let keyPair = await window.crypto.subtle.generateKey(
            {
                name: "RSA-OAEP",
                modulusLength: 4096,
                publicExponent: new Uint8Array([1, 0, 1]),
                hash: "SHA-256"
            },
            true,
            ["encrypt", "decrypt"]
        );
        let llavePublica = window.btoa(ab2str(await window.crypto.subtle.exportKey(
            "spki",
            keyPair.publicKey
        )));
        let llavePrivada = window.btoa(ab2str(await window.crypto.subtle.exportKey(
            "pkcs8",
            keyPair.privateKey
        )));
        this.keyPublicCifrado = '-----BEGIN PUBLIC KEY-----\n' + llavePublica + '\n-----END PUBLIC KEY-----';
        this.keyPrivateCifrado = '-----BEGIN PRIVATE KEY-----\n' + llavePrivada + '\n-----END PRIVATE KEY-----';
    }
    get llavePublica() {
        return this.keyPublicCifrado;
    }
    get llavePrivada() {
        return this.keyPrivateCifrado;
    }
    async cifrar(text, publicKey) {
        const encryptedText = this.nodeRSA.encryptStringWithRsaPublicKey({
            text: text,
            publicKey: publicKey
        });
        return encryptedText;
    }

    async descifrar(text, privateKey) {
        const decryptedText = this.nodeRSA.decryptStringWithRsaPrivateKey({
            text: text,
            privateKey: privateKey
        });

        return decryptedText;
    }
}

function str2ab(str) {
    const buf = new ArrayBuffer(str.length);
    const bufView = new Uint8Array(buf);
    for (let i = 0, strLen = str.length; i < strLen; i++) {
        bufView[i] = str.charCodeAt(i);
    }
    return buf;
}
function ab2str(buf) {
    return String.fromCharCode.apply(null, new Uint8Array(buf));
}
